export default __webpack_public_path__ + "static/media/Bird_Shooting_JavaScript_Game.e0552a64.PNG";